import { useState } from 'react';
import { FieldValues } from 'react-hook-form';

interface SubQuestion {
  code: string;
}

interface MappedQuestion {
  questionCode: string;
  questionId: string;
  answerValue: string;
  answerText: string;
  activity: string;
  type: string;
}

export const useQuestionnaire = () => {
  const [responseSubQuestion, setResponseSubQuestion] = useState<string[]>([]);
  const [validStep, setValidStep] = useState<any>();

  const validateStep = (values: any) => {
    responseSubQuestion.forEach(subQuestion => {
      delete values[subQuestion];
    });
    setValidStep({ ...validStep });
  };

  const validateInputs = (value: any) => {
    return value === undefined || value === '' || value === null || value?.length === 0
      ? 'Campo de preenchimento obrigatório'
      : true;
  };

  const validateSubQuestion = (
    response: boolean,
    items: SubQuestion[],
    array: FieldValues,
  ) => {
    const updatedSubQuestions = [...responseSubQuestion];
    if (!response) {
      items.forEach(item => updatedSubQuestions.push(item.code));
    } else {
      items.forEach(item => {
        const index = updatedSubQuestions.findIndex(
          question => question === item.code,
        );
        if (index >= 0) {
          updatedSubQuestions.splice(index, 1);
        }
      });
    }
    setResponseSubQuestion(updatedSubQuestions);
    setValidStep({ ...validStep });
    return true;
  };

  const editValues = (getValues: () => FieldValues) => {
    const inputs = getValues();

    Object.keys(inputs).forEach(key => {
      if (inputs[key] === undefined) {
        delete inputs[key];
      }
    });

    const answersArray = Object.keys(inputs).map(property => ({
      answerId: property,
      answerValue: inputs[property],
    }));

    return answersArray;
  };

  const transformValuesToExtraAnswers = (values: any, activityCodeMap: { [key: string]: string }) => {
    const result: { code: string; activity: string }[] = [];

    for (const [key, codesArray] of Object.entries(values)) {
      if (Array.isArray(codesArray)) {
        const activity = activityCodeMap[key];

        if (!activity) {
          console.warn(`Nenhum activity encontrado para a chave ${key}`);
          continue;
        }

        const transformedItems = codesArray.map(code => ({
          code: code,
          activity: activity,
        }));

        result.push(...transformedItems);
      }
    }

    return result;
  };

  function getAnswerText(question: any, answerValue: string): string {
    if (!question || !Array.isArray(question.items)) return '';
    const foundOption = question.items.find((option: any) => option.value === answerValue);
    return foundOption ? foundOption.text : '';
  }

  function mapQuestion(question: any, responses: Record<string, any>): MappedQuestion {
    const questionId = question.value;
    const answerValue = responses[questionId] || '';
    const answerText = getAnswerText(question, answerValue);
    
    return {
      questionCode: question.code,
      questionId,
      answerValue,
      answerText,
      activity: question.activityCode,
      type: question.type
    };
  }

  function mapQuestions(data: any[], responses: Record<string, any>): MappedQuestion[] {
    const mapped: MappedQuestion[] = [];
    data.forEach(section => {
      if (section.items && Array.isArray(section.items)) {
        section.items.forEach((question: any) => {
          mapped.push(mapQuestion(question, responses));
        });
      }
    });
    return mapped;
  }

  return {
    validateStep,
    validateInputs,
    validateSubQuestion,
    editValues,
    validStep,
    transformValuesToExtraAnswers,
    mapQuestions,
  };
};
